// Copyright (C) 2019 TANNER AG

import React, { useContext, useState } from "react";
import { withStyles, Dialog, DialogContent, DialogTitle, DialogActions } from "@material-ui/core";
import DefaultParameterTable from "./table";
import { Button } from "../components/button";
import { TranslationContext } from "../translation";

const CustomDialog = withStyles({
	paper: {
		borderRadius: 0
	},
	paperWidthMd: {
		maxWidth: 735
	}
})(Dialog);

const CustomDialogTitle = withStyles({
	root: {
		padding: "40px 40px 20px",
		fontSize: "22px",
		lineHeight: "30px",
		fontFamily: "MANEurope, Arial, sans-serif",
		letterSpacing: "-0.1px"
	}
})(DialogTitle);

const CustomDialogContent = withStyles({
	root: {
		padding: "0 40px 40px"
	}
})(DialogContent);

const CustomDialogActions = withStyles({
	root: {
		margin: "0 40px 40px",
		justifyContent: "center"
	}
})(DialogActions);

const styles = {
	trigger: {
		fontFamily: "MANEurope, Arial, sans-serif",
		fontSize: "15px",
		lineHeight: "22px",
		fontStyle: "normal",
		fontWeight: 300,
		color: "#303C49",
		opacity: 0.5,
		cursor: "pointer",
		"&:hover": {
			opacity: 1
		}
	}
};

export const DefaultParameterDialog = withStyles(styles)(({ classes }) => {
	const { translate } = useContext(TranslationContext);
	const [open, setOpen] = useState(false);
	const handleClose = () => setOpen(false);

	return (
		<React.Fragment>
			<div
				onClick={() => setOpen(true)}
				className={classes.trigger}
			>
				{translate("default.parameter.show")}
			</div>
			<CustomDialog open={open} fullWidth maxWidth="md" onClose={handleClose}>
				<CustomDialogTitle disableTypography>
					{translate("default.parameter.title")}
				</CustomDialogTitle>
				<CustomDialogContent>
					<DefaultParameterTable/>
				</CustomDialogContent>
				<CustomDialogActions>
					<Button variant="outlined" onClick={handleClose}>{translate("common.close.window")}</Button>
				</CustomDialogActions>
			</CustomDialog>
		</React.Fragment>
	);
});



// WEBPACK FOOTER //
// ./src/tco/defaultparamters/index.js